module.exports = __webpack_public_path__ + "static/media/Slide3-mobile.d90fb8c4.jpg";